<template>
  <div class="my-ai-teacher-title-bar">
    <div class="back-wrapper">
      <div class="back" @click="backHandle" v-if="!pathConfig.hideBack">
        <img src="./assets/icon_arrow_left.png" alt="" />
      </div>
    </div>
    <div class="title">AI体育老师</div>
    <div class="actions-wrapper">
      <div class="quit" @click="quit" v-if="pathConfig.hideBack">
        <img src="./assets/icon_close@2x.png" alt="" />
      </div>
      <div class="action" v-for="item in actionItemsActive" :key="item.action" @click="executeAction(item.action)">
        <img :src="item.icon" alt="" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { AppUtil } from 'kuaidong-lib'
import { BaseComponent } from 'kuaidong-component'
import { Component } from 'vue-property-decorator'
import { TitleBar, TitleBarActionEnum } from 'kuaidong-service'

import IconActionShare from './assets/icon_share@2x.png'
import IconActionAbout from './assets/icon_about2@2x.png'

@Component({})
export default class CustomTitleBar extends BaseComponent {
  pathConfig = TitleBar.pathConfig

  quit() {
    AppUtil.backToApp()
  }

  get title() {
    return TitleBar.getTitle()
  }

  get backPath() {
    return TitleBar.pathConfig.path
  }

  get actionItemMap() {
    return {
      [TitleBarActionEnum.Share]: {
        action: TitleBarActionEnum.Share,
        icon: IconActionShare,
      },
      [TitleBarActionEnum.About]: {
        action: TitleBarActionEnum.About,
        icon: IconActionAbout,
      },
    }
  }

  get actionItemsActive() {
    return this.pathConfig.eventEmitter.listeners.map(
      (listener) => this.actionItemMap[listener[0] as TitleBarActionEnum]
    )
  }

  backHandle() {
    this.$emit('back')
  }

  executeAction(action: TitleBarActionEnum) {
    TitleBar.fire(action)
  }
}
</script>

<style lang="less">
.my-ai-teacher-title-bar {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  width: 100%;
  height: 52px;
  background: #fff;
  border-bottom: 1px solid transparent;
  z-index: 9999;
  box-sizing: border-box;

  > .title {
    line-height: 20px;
    font-size: 14px;
    font-weight: 600;
    color: #000;
  }

  > .back-wrapper,
  > .actions-wrapper {
    width: 34px;
    height: 34px;
    font-size: 16px;
    color: #939599;
  }

  > .back-wrapper {
    > .back {
      padding: 8px;

      > img {
        width: 18px;
        height: 18px;
      }
    }
  }

  > .actions-wrapper {
    > .quit {
      > img {
        width: 34px;
        height: 34px;
      }
    }

    > .action {
      padding: 5px;

      > img {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
